import { Link, useNavigate } from "react-router-dom";
import { KeyRound, LogOut, Settings, ShieldCheck, UserCog } from "lucide-react";
import { Avatar, AvatarFallback, identicon } from "@/components/ui/avatar";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useCurrentUser, useLogout } from "@/lib/auth";

export function UserMenu() {
  const me = useCurrentUser();
  const nav = useNavigate();
  const logout = useLogout();
  if (!me.data) return null;
  const ic = identicon(me.data.email);

  async function doLogout() {
    await logout.mutateAsync();
    nav("/login");
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60" aria-label="Account menu">
        <Avatar>
          <AvatarFallback className="text-white" style={{ background: ic.bg }}>
            {ic.initials}
          </AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-56">
        <DropdownMenuLabel className="normal-case tracking-normal text-sm font-normal text-foreground">
          Signed in as <span className="font-semibold">{me.data.email}</span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/account"><UserCog className="h-3.5 w-3.5" /> Account</Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/account/tokens"><KeyRound className="h-3.5 w-3.5" /> API tokens</Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/account/preferences"><Settings className="h-3.5 w-3.5" /> Preferences</Link>
        </DropdownMenuItem>
        {me.data.isSuperadmin && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link to="/admin"><ShieldCheck className="h-3.5 w-3.5" /> Platform admin</Link>
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={doLogout} className="text-danger focus:text-danger">
          <LogOut className="h-3.5 w-3.5" /> Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
